import { AccessCheck } from "@particles/index"

import { Table } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

export default function VendorTableView() {
    return (
        <TableView.Table>
            <Table.Column<Vendor>
                accessorKey="name"
                header="Vendor"
                size={224}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Vendor>
                accessorKey="account_id"
                header="Account ID"
                size={128}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Vendor>
                accessorKey="billing_address_formatted"
                header="Billing address"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Vendor>
                accessorKey="labels"
                header="Labels"
                size={240}
                cell={({ getValue }) => (
                    <Table.Cells.BadgesCell
                        badges={(getValue() as VendorLabel[])?.map((label: VendorLabel) => label.name)}
                    />
                )}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Vendor>
                accessorKey="payment_terms"
                header="Terms"
                size={144}
                cell={({ getValue }) => <Table.Cells.PaymentTermsCell terms={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="other"
            />
            <Table.Column<Vendor>
                accessorKey="default_billing_vendor_name"
                header="Bills Via"
                size={224}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <AccessCheck entitlements={["entitlement_purchase_orders_enabled"]}>
                <Table.Column<Vendor>
                    accessorKey="current_purchase_order_count"
                    header="Current POs"
                    size={144}
                    cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="number" />}
                    enableSorting={true}
                    enablePinning={true}
                    dataType="numerical"
                    alignment="right"
                />
                <Table.Column<Vendor>
                    accessorKey="outstanding_commitments"
                    header="Commitments"
                    size={160}
                    cell={({ getValue }) => (
                        <Table.Cells.NumericalDataCell value={getValue()} ignoreZero={true} type="currency" />
                    )}
                    enableSorting={true}
                    enablePinning={true}
                    dataType="numerical"
                />
            </AccessCheck>
            <AccessCheck entitlements={["entitlement_bills_enabled"]}>
                <Table.Column<Vendor>
                    accessorKey="outstanding_payables"
                    header="Payables"
                    size={160}
                    cell={({ getValue }) => (
                        <Table.Cells.NumericalDataCell value={getValue()} ignoreZero={true} type="currency" />
                    )}
                    enableSorting={true}
                    enablePinning={true}
                    dataType="numerical"
                />
                <Table.Column<Vendor>
                    accessorKey="unapplied_credit"
                    header="Unapplied Credit"
                    size={176}
                    cell={({ getValue }) => (
                        <Table.Cells.NumericalDataCell value={getValue()} ignoreZero={true} type="currency" />
                    )}
                    enableSorting={true}
                    enablePinning={true}
                    dataType="numerical"
                />
                <Table.Column<Vendor>
                    accessorKey="amount_owed"
                    header="Amount Owed"
                    size={160}
                    cell={({ getValue }) => (
                        <Table.Cells.NumericalDataCell value={getValue()} ignoreZero={true} type="currency" />
                    )}
                    enableSorting={true}
                    enablePinning={true}
                    dataType="numerical"
                />
            </AccessCheck>
            <Table.Column<Vendor>
                accessorKey="website"
                header="Website"
                size={224}
                cell={({ getValue }) => <Table.Cells.LinkCell destination={getValue()} />}
                enableSorting={false}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Vendor>
                accessorKey="last_modified_at"
                header="Last modified"
                size={176}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
        </TableView.Table>
    )
}
